"use client";

import { c as _c } from "react/compiler-runtime";
import { FileText, Download, ExternalLink, Clock } from "lucide-react";
import type { DealDocumentWithHref } from "@/lib/deals/types";
interface DocumentDownloadsProps {
  /** Authorized seam endpoint for the signed contract (finding H3), or null. */
  signedContractHref?: string | null;
  documents?: DealDocumentWithHref[] | null;
  className?: string;
}

/**
 * DocumentDownloads - Displays downloadable documents for a completed deal
 */
export function DocumentDownloads(t0) {
  const $ = _c(20);
  const {
    signedContractHref,
    documents,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== className || $[1] !== documents || $[2] !== signedContractHref) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const allDocuments = [];
      if (signedContractHref) {
        allDocuments.push({
          name: "Unterschriebener Kaufvertrag",
          downloadHref: signedContractHref,
          type: "contract",
          isContract: true
        });
      }
      if (documents?.length) {
        allDocuments.push(...documents.map(_temp));
      }
      if (allDocuments.length === 0) {
        const t7 = `rounded-lg border border-zinc-200 bg-zinc-50 p-6 ${className}`;
        let t8;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
          t8 = <div className="flex items-center gap-3 text-zinc-500"><FileText className="w-5 h-5" /><p className="text-sm">Keine Dokumente verfügbar.</p></div>;
          $[8] = t8;
        } else {
          t8 = $[8];
        }
        let t9;
        if ($[9] !== t7) {
          t9 = <div className={t7}>{t8}</div>;
          $[9] = t7;
          $[10] = t9;
        } else {
          t9 = $[10];
        }
        t6 = t9;
        break bb0;
      }
      const getFileIcon = _temp2;
      t4 = `rounded-lg border border-zinc-200 bg-white ${className}`;
      if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <div className="p-5 border-b border-zinc-100"><h3 className="font-semibold text-zinc-900">Dokumente</h3><p className="text-sm text-zinc-500 mt-1">Laden Sie Ihre Transaktionsdokumente herunter</p></div>;
        $[11] = t5;
      } else {
        t5 = $[11];
      }
      t2 = "divide-y divide-zinc-100";
      t3 = allDocuments.map((doc, index) => {
        const FileIcon = getFileIcon(doc.type);
        return <div key={index} className={`p-4 flex items-center gap-4 ${doc.isContract ? "bg-primary/5" : ""}`}><div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${doc.isContract ? "bg-primary/10 text-primary" : "bg-zinc-100 text-zinc-500"}`}><FileIcon className="w-5 h-5" /></div><div className="flex-1 min-w-0"><p className={`text-sm font-medium truncate ${doc.isContract ? "text-primary" : "text-zinc-900"}`}>{doc.name}</p>{doc.uploaded_at && <p className="text-xs text-zinc-400 flex items-center gap-1 mt-0.5"><Clock className="w-3 h-3" />{new Date(doc.uploaded_at).toLocaleDateString("de-DE")}</p>}</div><div className="flex items-center gap-2"><a href={doc.downloadHref} target="_blank" rel="noopener noreferrer" className="p-2 hover:bg-zinc-100 rounded-lg transition-colors" title={"In neuem Tab \xF6ffnen"}><ExternalLink className="w-4 h-4 text-zinc-500" /></a><a href={doc.downloadHref} className={`px-3 py-1.5 text-sm font-medium rounded-lg flex items-center gap-2 transition-colors ${doc.isContract ? "bg-primary hover:bg-primary/90 text-white" : "bg-zinc-100 hover:bg-zinc-200 text-zinc-700"}`}><Download className="w-4 h-4" /><span className="hidden sm:inline">Download</span></a></div></div>;
      });
    }
    $[0] = className;
    $[1] = documents;
    $[2] = signedContractHref;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t3) {
    t7 = <div className={t2}>{t3}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="p-4 bg-zinc-50 border-t border-zinc-100"><p className="text-xs text-zinc-500">Diese Dokumente sind für 12 Monate verfügbar. Bitte speichern Sie eine lokale Kopie für Ihre Unterlagen.</p></div>;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t4 || $[17] !== t5 || $[18] !== t7) {
    t9 = <div className={t4}>{t5}{t7}{t8}</div>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t7;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}
function _temp2(_type) {
  return FileText;
}
function _temp(d) {
  return {
    name: d.name,
    downloadHref: d.downloadHref,
    type: d.type,
    uploaded_at: d.uploaded_at
  };
}